<div class="popup-wrapper">
    <div class="popup-header">
        <span class="material-icons-round cyan">store</span>
        <span class="soc-panel-h">{{(editFlag ? 'SUPPLIERS.EDIT_SUPPLIER' : "SUPPLIERS.NEW_SUPPLIER") |
            translate}}</span>
    </div>
    <hr class="soc-panel-line">
        
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-input-wrapper">
            <label for="name" class="soc-input-lbl w-100 text-start">{{('SUPPLIERS.SUPPLIER_NAME')|translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="name.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': name.invalid && f.submitted}" id="reason" required name="name" #name="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="supplierDto.name">
            </div>
        </div>

        <div class="soc-input-wrapper">
            <label for="address" class="soc-input-lbl w-100 text-start">{{('SUPPLIERS.ADDRESS')|translate}}</label>
            <div class="soc-error-field-wrapper">
               <!-- <span *ngIf="address.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span> 
                <input [ngClass]="{'soc-error-active': address.invalid && f.submitted}" id="reason" required name="address" #address="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="supplierDto.address"> -->
                <input name="address" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="supplierDto.address">
            </div>
        </div>

        <div class="soc-input-wrapper">
            <label for="email" class="soc-input-lbl w-100 text-start">{{('SUPPLIERS.EMAIL')|translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="email.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': email.invalid && f.submitted}" id="reason" required name="email" #email="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="supplierDto.email">
            </div>
        </div>

        <div class="soc-input-wrapper">
            <label for="phone" class="soc-input-lbl w-100 text-start">{{('SUPPLIERS.PHONE_NUMBER')|translate}}</label>
            <div class="soc-error-field-wrapper">
                <!-- <span *ngIf="phone.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': phone.invalid && f.submitted}" id="reason" required name="phone" #phone="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="supplierDto.phone"> -->
                <input name="phone" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="supplierDto.phone">
            </div>
        </div>

        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 justify-content-end">
            <button class="soc-secondary-cyan-btn" type="button" (click)="cancel()">{{'CANCEL'| translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit"
                (click)="editFlag? editSupplier(f) : addSupplier(f) ">{{(editFlag ? 'SAVE_CHANGES' : 'CREATE')| translate}}</button>
        </div>
    </form>
</div>